/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupResponseModel } from './LookupResponseModel';
import {
    LookupResponseModelFromJSON,
    LookupResponseModelFromJSONTyped,
    LookupResponseModelToJSON,
} from './LookupResponseModel';

/**
 * 
 * @export
 * @interface AllowedRulesResponseModel
 */
export interface AllowedRulesResponseModel {
    /**
     * 
     * @type {LookupResponseModel}
     * @memberof AllowedRulesResponseModel
     */
    parent: LookupResponseModel;
    /**
     * 
     * @type {Array<LookupResponseModel>}
     * @memberof AllowedRulesResponseModel
     */
    children: Array<LookupResponseModel>;
}

/**
 * Check if a given object implements the AllowedRulesResponseModel interface.
 */
export function instanceOfAllowedRulesResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parent" in value;
    isInstance = isInstance && "children" in value;

    return isInstance;
}

export function AllowedRulesResponseModelFromJSON(json: any): AllowedRulesResponseModel {
    return AllowedRulesResponseModelFromJSONTyped(json, false);
}

export function AllowedRulesResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedRulesResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parent': LookupResponseModelFromJSON(json['Parent']),
        'children': ((json['Children'] as Array<any>).map(LookupResponseModelFromJSON)),
    };
}

export function AllowedRulesResponseModelToJSON(value?: AllowedRulesResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Parent': LookupResponseModelToJSON(value.parent),
        'Children': ((value.children as Array<any>).map(LookupResponseModelToJSON)),
    };
}

